import { type SpaLocation } from "~/core/ts/entity/Spa"

export const useLocation = (location: SpaLocation) => {
  const key = 'AIzaSyBsO9KgBGD5G5qxuljbE0H5RalWNgS5QwY'
  const address = encodeURI(location.address)

  const config = useRuntimeConfig()
  const lang   = config.public.language

  const locationLabel = (() => {
    if (location) {
      if (location.state) {
        return location.state
      }

      return `${location.address}, ${location.country}`
    }

    return ''
  })()

  const fullAddressLabel = (() => {
    if (location) {
      return location.address
    }

    return ''
  })()
  const externalMapLink = `https://maps.google.com/maps/place/${address}`

  const embedMapLink = `https://www.google.com/maps/embed/v1/place?key=${key}&q=${address}&language=${lang}`

  return {
    locationLabel,
    fullAddressLabel,
    externalMapLink,
    embedMapLink,
  }
}
